<script>
import { Bar } from "vue-chartjs";
import { groupBy } from "@/services/utils.js";
import { LegendExcessMeasurement } from "@/configs/legenda.js";

// apexcharts
export default {
  name: "IkpMedParamsExcessMeasurementChart",
  extends: Bar,

  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      options: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                stepSize: 1,
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              const label = data.datasets[tooltipItem.datasetIndex].label;
              const item = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              const p = Math.round(item.params.percent);
              let str = `${label}: ${item.y}`;

              if (item.params.totalMeasurementsCount) {
                str += ` из ${item.params.totalMeasurementsCount} измерений`;
              }

              if (p) {
                str += `, ${p}% превышений`;
              }

              return str;
            },
          },
        },
      },
    };
  },

  computed: {
    labels() {
      return [...new Set(this.items.map(item => item.date_without_time))];
    },

    dataset() {
      const data = [];
      const groups = groupBy("med_param_name")(this.items);
      Object.keys(groups).forEach(paramName => {
        const items = groups[paramName].map(item => ({
          x: item.date_without_time,
          y: item.result,
          params: { totalMeasurementsCount: item.all_results_cnt, percent: Number(item.percent), danger: item.has_danger },
        }));

        data.push({
          label: paramName,
          backgroundColor: items.map(item => {
            if (item.params.danger) {
              return LegendExcessMeasurement.red;
            } else if (item.params.percent > 15) {
              return LegendExcessMeasurement.yellow;
            }

            // зеленый - все в норме
            return LegendExcessMeasurement.green;
          }),
          data: items,
        });
      });

      return data;
    },
  },

  watch: {
    items() {
      this.render();
    },
  },

  async mounted() {
    this.render();
  },

  methods: {
    render() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: this.dataset,
        },
        this.options,
      );
    },
  },
};
</script>
